// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__T9esl","Actions":"styles_Actions__WuYxh","DropDown":"styles_DropDown__AcKrr"};